import { render, staticRenderFns } from "./DeliveriesList.vue?vue&type=template&id=fd370faa&"
import script from "./DeliveriesList.vue?vue&type=script&lang=js&"
export * from "./DeliveriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports